import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";

// img
import u1 from "../../../Assets/images/authbg.png";
import { Link, useNavigate } from "react-router-dom";
import { CstmPagination } from "../../../components/Common/Common";
import { REFUND_LIST } from "../../../services/ApiCalls";
import Filter from "../../../components/Common/Filter";
import {
  activeInActiveArr,
  activeInactiveOptions,
} from "../../../utilities/const";
import CustomPagination from "../../../components/Common/CustomPagination";
import dataHandler from "../../../hooks/dataHandler";

const Refund = () => {
  const navigate = useNavigate();
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: REFUND_LIST,
  });

  const column = [
    {
      head: "Appt ID",
      accessor: "#",
      component: (item, key) => {
        return <>{item?.order?.customOrderId}</>;
      },
    },
    {
      head: "User",
      accessor: "#",
      component: (item, key) => {
        return <>{item?.order?.user?.name}</>;
      },
    },
    {
      head: "Expert",
      accessor: "#",
      component: (item, key) => {
        return <>{item?.order?.vendor?.name}</>;
      },
    },
    {
      head: "Category",
      accessor: "#",
      component: (item, key) => {
        return <>{item?.order?.serviceType?.catName}</>;
      },
    },
    {
      head: "Amount",
      accessor: "#",
      component: (item, key) => {
        return <>{item?.amount}</>;
      },
    },
    {
      head: "Duration",
      accessor: "#",
      component: (item, key) => {
        return <>{item?.order?.duration}</>;
      },
    },
    {
      head: "Appt Date",
      accessor: "createdAt",
      component: (item, key, arr) => (
        <>{moment(item.order?.date_created_utc).format("DD-MM-YYYY , HH:MM")}</>
      ),
    },
    {
      head: "Refund Reason",
      accessor: "#",
      component: (item, key) => {
        return <>{item?.reason}</>;
      },
    },
    {
      head: "Notes",
      accessor: "#",
      component: (item, key) => {
        return <>{item?.reason}</>;
      },
    },
    // {
    //   head: "Order Id",
    //   accessor: "PlatformUser",
    //   component: (item, key, arr) => (
    //     <p className="m-0 fw-sbold">{item.PlatformUser}</p>
    //   ),
    // },
    {
      head: "Action",
      accessor: "Action",
      component: (item, key, arr) => (
        <div className="actionBtn d-flex align-items-center gap-10">
          <div
            className="border-0 p-0"
            variant="transparent"
            onClick={() => navigate("/help/detail", { state: item })}
            style={{ cursor: "pointer" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="13"
              viewBox="0 0 21 13"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.1269 0.379883C6.00023 0.379883 2.81476 3.30125 1.26883 5.0114C0.614598 5.73509 0.23969 6.2714 0.23969 6.2714C0.0900251 6.48573 0.0900251 6.77233 0.23969 6.98666C0.23969 6.98666 0.534721 7.40936 1.05152 8.0024C2.50253 9.6674 5.79632 12.8782 10.1269 12.8782C14.572 12.8782 17.9291 9.49839 19.3181 7.87307C19.7642 7.35098 20.0152 6.98666 20.0152 6.98666C20.1649 6.77233 20.1649 6.48573 20.0152 6.2714C20.0152 6.2714 19.7398 5.87467 19.2535 5.31173C17.8276 3.6621 14.5055 0.379883 10.1269 0.379883ZM10.1269 1.62996C13.8634 1.62996 16.9827 4.59581 18.3074 6.12852C18.5725 6.43529 18.5974 6.48424 18.7089 6.63143C18.605 6.76803 18.593 6.79697 18.3671 7.06124C17.0781 8.56964 13.9201 11.6281 10.1269 11.6281C6.43137 11.6281 3.34181 8.72873 1.99268 7.18081C1.70294 6.8484 1.67185 6.78672 1.55443 6.63143C1.69037 6.45001 1.77636 6.31473 2.19543 5.85135C3.63536 4.25828 6.60534 1.62996 10.1269 1.62996ZM10.1269 2.88004C8.06297 2.88004 6.38027 4.56274 6.38027 6.62663C6.38027 8.69036 8.06297 10.378 10.1269 10.378C12.1906 10.378 13.8783 8.69036 13.8783 6.62663C13.8783 4.56274 12.1906 2.88004 10.1269 2.88004ZM10.1269 4.13127C11.5152 4.13127 12.6282 5.23814 12.6282 6.62663C12.6282 8.01496 11.5152 9.12794 10.1269 9.12794C8.73837 9.12794 7.6315 8.01496 7.6315 6.62663C7.6315 5.23814 8.73837 4.13127 10.1269 4.13127Z"
                fill="#645C5C"
              />
            </svg>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <secstion className="refund position-relative py-3">
        <Container className="py-3">
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Refund Management
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                body={body}
                pageChangeHandler={paginationHandler}
                setBody={setBody}
                total={total}
              />
            </Col>
          </Row>
        </Container>
      </secstion>
    </>
  );
};

export default Refund;
